Vue.component("knowledge_point_modal", {
  props: {
  },
  data(){
    return{
      knowledgeModalVisible: false,//知识点弹窗
      knowledgeModalInfo: {},//知识点内容
      selectKnowledgeInfo: {},//选中知识点内容
    }
  },
  methods: {
    //点击知识点
    open(point) {
      const that = this
      console.log(point)
      API.reqKnowledgePointFrom({ pointFragmentsId: point.pointFragmentsId }).then(res => {
        console.log(res)
        if (res.status == 200) {
          this.knowledgeModalInfo = res.data
          let froms = []
          Object.keys(res.data).map(key => {
            if (res.data[key] && res.data[key].length) {
              froms.push(...res.data[key])
            }
          })
          if(!froms.length){
            //无
            // if((window.ifManager || window.ifTeacher) || location.pathname.indexOf('/resources/search') != -1){
            //   //管理员角色，跳转资源库
            //   location.href = '/rman/#/basic/rmanDetail/' + point.videoId + '?inpoint=' + point.inPoint + '?hidebtn=true&isSysAuth=true'
            // }else{
            //   this.$message.warning(this.$t('该知识点暂未开放给学生查看~'))
            // }
            if(location.pathname.indexOf('/resources/search') != -1){
              location.href = '/rman/#/basic/rmanDetail/' + point.videoId + '?inpoint=' + point.inPoint + '?hidebtn=true&isSysAuth=true'
            }
          } else if (froms.length == 1) {
            //只有一个，直接跳转
            this.selectKnowledgeInfo = froms[0]
            console.log(this.selectKnowledgeInfo)
            this.handleConfirmKnowledgePoint()
          } else {
            //有多个，弹框
            that.knowledgeModalVisible = true
          }
        } else {
          this.$message.error(this.$t('获取信息错误！'))
        }
      })
    },
    //知识点跳转确认
    handleConfirmKnowledgePoint() {
      if (!this.selectKnowledgeInfo.contentId_) return this.$message.info(this.$t('请选择内容！'))
      if(!window.hasLogin) return location.href = window.loginHref //跳转登录
      // let url
      console.log(this.selectKnowledgeInfo)
      let courseId = (this.selectKnowledgeInfo.course_id || this.selectKnowledgeInfo.courseId)
      let pointId = this.selectKnowledgeInfo.pointFragmentsId
      if (this.selectKnowledgeInfo.courseType == 0) {
        //跳转微课
        this.handleGlobalJoinCourse({courseId,pointId,ifMicro: true})
      } else if (this.selectKnowledgeInfo.courseType == 1) {
        //公开课
        this.handleGlobalJoinCourse({courseId,sectionId:this.selectKnowledgeInfo.identification,pointId,chooseRole:0})
        // url = '/learn/course/mooc/' + (this.selectKnowledgeInfo.course_id || this.selectKnowledgeInfo.courseId) + '/' + this.selectKnowledgeInfo.identification + '?pointId=' + this.selectKnowledgeInfo.pointFragmentsId
      } else if (this.selectKnowledgeInfo.courseType == 2) {
        //班级课
        this.handleGlobalJoinCourse({courseId,sectionId:this.selectKnowledgeInfo.identification,pointId,chooseRole:0})
        // url = '/learn/course/spoc/' + (this.selectKnowledgeInfo.course_id || this.selectKnowledgeInfo.courseId) + '/' + this.selectKnowledgeInfo.identification + '?pointId=' + this.selectKnowledgeInfo.pointFragmentsId
      } else if (this.selectKnowledgeInfo.courseType == 3) {
        //课程资源包
        url = '/learn/workbench/#/tempatedetail/courseInfo?id=' + this.selectKnowledgeInfo.contentId_ + '&type=see'
      } else if (this.selectKnowledgeInfo.courseType == 4) {
        //课程地图
        url = '/learn/workbench/#/perviewemap?mapid=' + (this.selectKnowledgeInfo.course_id || this.selectKnowledgeInfo.courseId)
      } else if (this.selectKnowledgeInfo.courseType == 5) {
        //在线课堂
        url = '/learn/videoreview/' + (this.selectKnowledgeInfo.course_id || this.selectKnowledgeInfo.courseId) + '?schoolYear=' + this.selectKnowledgeInfo.schoolYear + '&semester=' + this.selectKnowledgeInfo.semester
      }
      // console.log(url, this.selectKnowledgeInfo)
      // window.open(url)
    }
  },
  template: `
  <el-dialog :title="$t('选择内容')" class="knowledge_point_modal" :visible.sync="knowledgeModalVisible">
  <div class="top_tips">{{$t('有多个内容均包含次知识点，请')}}<span>{{$t('选择一个')}}</span>{{$t('来查看此知识点')}}</div>
  <el-tabs>
      <el-tab-pane v-if="knowledgeModalInfo.course && knowledgeModalInfo.course.length">
          <template slot="label">
              <span>{{$t('课程')}}</span>
              <span>({{knowledgeModalInfo.course.length}})</span>
          </template>
          <div class="knowledge_course_list">
              <div class="item" :class="{active: item.contentId_ == selectKnowledgeInfo.contentId_}" v-for="(item,i) in knowledgeModalInfo.course" :key="i" @click="selectKnowledgeInfo = item">
                  <img class="cover" :src="item.course_cover || item.keyFramePath" alt="">
                  <div class="content">
                      <div class="name">
                          {{item.courseName}}
                      </div>
                      <div class="tips">
                          <span v-if="item.collegeName && item.collegeName.length">{{(item.collegeName || []).join(',')}}&nbsp;&nbsp;</span>
                          <span>{{(item.teacherNames || []).join(',')}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </el-tab-pane>
      <el-tab-pane v-if="knowledgeModalInfo.onlineCourse && knowledgeModalInfo.onlineCourse.length">
          <template slot="label">
              <span>{{$t('在线课堂')}}</span>
              <span>({{knowledgeModalInfo.onlineCourse.length}})</span>
          </template>
          <div class="knowledge_online_list">
              <div class="item" :class="{active: item.contentId_ == selectKnowledgeInfo.contentId_}" v-for="(item,i) in knowledgeModalInfo.onlineCourse" :key="i" @click="selectKnowledgeInfo = item">
                  <img class="cover" :src="item.course_cover || item.keyFramePath" alt="">
                  <div class="content">
                      <div class="name">
                          {{item.name_}}
                      </div>
                      <div class="tips">
                          <span>{{(item.teacherNames || []).join(',')}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </el-tab-pane>
      <el-tab-pane v-if="knowledgeModalInfo.map && knowledgeModalInfo.map.length">
          <template slot="label">
              <span>{{$t('课程地图')}}</span>
              <span>({{knowledgeModalInfo.map.length}})</span>
          </template>
          <div class="knowledge_map_list">
              <div class="item" :class="{active: item.contentId_ == selectKnowledgeInfo.contentId_}" v-for="(item,i) in knowledgeModalInfo.map" :key="i" @click="selectKnowledgeInfo = item">
                  <img class="cover" :src="item.course_cover || item.keyFramePath" alt="">
                  <div class="content">
                      <div class="name">
                          {{item.name_}}
                      </div>
                      <div class="tips">
                          <span v-if="item.collegeName && item.collegeName.length">{{(item.collegeName || []).join(',')}}&nbsp;&nbsp;</span>
                          <span>{{(item.teacherNames || []).join(',')}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </el-tab-pane>
      <el-tab-pane v-if="knowledgeModalInfo.template && knowledgeModalInfo.template.length">
          <template slot="label">
              <span>{{$t('课程资源包')}}</span>
              <span>({{knowledgeModalInfo.template.length}})</span>
          </template>
          <div class="knowledge_resource_list">
              <div class="item" :class="{active: item.contentId_ == selectKnowledgeInfo.contentId_}" v-for="(item,i) in knowledgeModalInfo.template" :key="i" @click="selectKnowledgeInfo = item">
                  <img class="cover" :src="item.course_cover || item.keyFramePath" alt="">
                  <div class="content">
                      <div class="name">
                          {{item.name_}}
                      </div>
                      <div class="tips">
                          <span>{{(item.teacherNames || []).join(',')}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </el-tab-pane>
  </el-tabs>
  <el-button type="primary" size="mini" @click="handleConfirmKnowledgePoint">{{$t('确认')}}</el-button>
</el-dialog>`
});